import { ErrorType, IErrorNormalizer, VmafError } from './types';

class VideoMakerVideoErrorNormalizer implements IErrorNormalizer {
  normalizeToVmafError(e: any): VmafError {
    return new VmafError(
      e.message,
      this.checkAuthError(e) || this.check404Error(e) || ErrorType.MEDIA,
      // TODO: change to checkMediaError(e) || ErrorType.UNKNOWN, if/when Magisto will provide error on unsupported media
      // TODO: add checkMissedArgumentError(e) after bug fixed https://jira.wixpress.com/browse/WVM-1210
      e,
    );
  }

  private checkAuthError(e: any): ErrorType | null {
    if (e.response && e.response.status === 401) {
      return ErrorType.UNAUTHORIZED;
    }

    return null;
  }

  private check404Error(e: Error) {
    if (e.message === 'Network Error') {
      return ErrorType.NOT_FOUND;
    }
  }
}

export default VideoMakerVideoErrorNormalizer;
